<template>
  <div
    class="tw-grid tw-grid-cols-12 first:tw-rounded-t-lg last:tw-rounded-b-lg tw-border tw-border-t-0 first:tw-border-t tw-items-center last:border-b-0 tw-border-neutral-300"
  >
    <slot />
  </div>
</template>
